function freelanceHomePage(dispatch) {
    dispatch({ type: "newuserfalse" });
    dispatch({ type: "recruitertrue" });
    dispatch({ type: "recruiterCandidatefalse"});
    dispatch({ type: "freelancetrue"});
}

export { freelanceHomePage };